import { Badge, TablePanel, Tooltip } from "components/common";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { callGetApiWithAuth } from "utils/api";
import { asUsdPrice } from "utils/text";
import { varKey, varLabel } from "common/var";
import { asDate } from "utils/text";

export default function SentTable(props) {
  const [tableData, setTableData] = useState([]);
  const [paginationParam, setPaginationParam] = useState({
    currentPage: 1,
    perPage: 15,
    total: 0,
  });
  const [isLoading, setIsLoading] = useState(false);

  const onGetTableData = (res) => {
    setIsLoading(false);
    setTableData(res.data.data);
    setPaginationParam({
      ...paginationParam,
      currentPage: res.data.current_page,
      total: res.data.total,
    });
  };
  const onFailTableData = () => {
    setIsLoading(false);
  };
  const loadTableData = (paginationParam0) => {
    const params = {
      page: paginationParam0.currentPage,
      per_page: paginationParam0.perPage,
    };
    const q = Object.keys(params)
      .map((k) => k + "=" + params[k])
      .join("&");
    setIsLoading(true);
    callGetApiWithAuth(
      `my_account/loyalty_wallet/sent_histories?${q}`,
      onGetTableData,
      onFailTableData
    );
  };

  const onPageChange = (page) => {
    const paginationParam0 = {
      ...paginationParam,
      currentPage: page,
    };
    loadTableData(paginationParam0);
  };

  useEffect(() => {
    loadTableData(paginationParam);
  }, []);

  useEffect(() => {
    if (props.shouldLoad) {
      loadTableData(paginationParam);
    }
  }, [props.shouldLoad]);

  return (
    <Wrapper>
      <TablePanel
        className="transfer-table-panel"
        data={tableData}
        pagination={paginationParam}
        onPageChange={onPageChange}
        loading={isLoading}
        columns={[
          {
            title: "Date",
            key: "date",
            render: (_, record) => <span>{asDate(record.created_at)}</span>,
          },
          {
            title: "Amount",
            key: "amount",
            render: (_, record) => <span>{asUsdPrice(record.amount)}</span>,
          },
          {
            title: "Receiver",
            key: "receiver",
            render: (_, record) => (
              <span>
                {record.receiver
                  ? `${record.receiver.first_name} ${record.receiver.last_name}`
                  : `${record.receiver_first_name} ${record.receiver_last_name}`}
              </span>
            ),
          },
          {
            title: "Status",
            key: "status",
            render: (_, record) => (
              <span>
                <Badge
                  type={"loyaltyTransferHistoryStatus"}
                  keyName={varKey(
                    "loyaltyTransferHistory.status",
                    record.status
                  )}
                  label={varLabel(
                    "loyaltyTransferHistory.status",
                    record.status
                  )}
                />
              </span>
            ),
          },
          {
            title: "Description",
            key: "s_comment",
            render: (_, record) => (
              <Tooltip title={record.s_comment}>
                <span className="tooltip-description">{record.s_comment}</span>
              </Tooltip>
            ),
          },
        ]}
      />
    </Wrapper>
  );
}

export const Wrapper = styled.div`
  .cardRoot {
    box-shadow: none;
    padding: 0;
  }
  .panelHead {
    padding: 0;
  }
  .transfer-table-panel {
  }
`;
